import { storage } from '../../lib/storage';
import { notify } from '../../utils/toast';

export const saveWalletInfo = (walletAddress: string, balance: number, minBalance: number, rekeyTo?: string) => {
  localStorage.setItem('walletBalance', balance.toString());
  localStorage.setItem('walletMinBalance', minBalance.toString());
  if (rekeyTo) {
    localStorage.setItem('walletRekeyTo', rekeyTo);
  }
};

export const clearWalletInfo = async (walletAddress: string) => {
  try {
    if (walletAddress) {
      await storage.removeProfile(walletAddress);
    }

    localStorage.removeItem('walletType');
    localStorage.removeItem('walletAddress');
    localStorage.removeItem('nfdName');
    localStorage.removeItem('walletBalance');
    localStorage.removeItem('walletMinBalance');
    localStorage.removeItem('walletRekeyTo');
    localStorage.removeItem('goplausible_token');
    localStorage.removeItem('walletconnect');
  } catch (error) {
    console.error('Clear wallet info error:', error);
    notify.error('Failed to clear wallet information');
    throw error;
  }
};
